import * as Sentry from '@sentry/react';
import { SENTRY_DSN } from './constants';

export function initSentry() {
  if (!SENTRY_DSN) return;

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.MODE,
    release: `grupo-dim-app@${import.meta.env.VITE_APP_VERSION ?? '0.1.0'}`,

    // Capture 100% of errors, 20% of performance transactions
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,

    // Only report in production
    enabled: import.meta.env.PROD,

    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],

    // Scrub tokens from breadcrumbs
    beforeBreadcrumb(breadcrumb) {
      if (breadcrumb.category === 'xhr' || breadcrumb.category === 'fetch') {
        if (breadcrumb.data?.url) {
          try {
            const url = new URL(breadcrumb.data.url, window.location.origin);
            url.searchParams.delete('token');
            breadcrumb.data.url = url.toString();
          } catch {
            // ignore malformed URLs
          }
        }
      }
      return breadcrumb;
    },
  });
}

export { Sentry };
